import Api from './api';
import { PageResponse } from '@/schema/page';
import {
  InvitationAccept,
  InvitationCreate,
  InvitationPreview,
  InvitationResponse,
} from '@/schema/invitation';

const InvitationApi = {
  getAll(page: number, size: number, clinicId?: string) {
    const params = new URLSearchParams({ page: String(page), size: String(size) });
    if (clinicId) params.set('clinicId', clinicId);
    return Api.get<PageResponse<InvitationResponse>>(`/invitations?${params.toString()}`);
  },

  create(data: InvitationCreate) {
    return Api.post<InvitationResponse>('/invitations', data);
  },

  revoke(id: string) {
    return Api.post<InvitationResponse>(`/invitations/${id}/revoke`, {});
  },

  resend(id: string) {
    return Api.post<InvitationResponse>(`/invitations/${id}/resend`, {});
  },

  /** Drops the row. Revoking is the softer option and keeps the record. */
  delete(id: string) {
    return Api.delete<void>(`/invitations/${id}`);
  },

  // The two below are the only unauthenticated calls in the app besides login.
  preview(token: string) {
    return Api.get<InvitationPreview>(`/auth/invitations/${token}`);
  },

  accept(token: string, data: InvitationAccept) {
    return Api.post<string>(`/auth/invitations/${token}/accept`, data);
  },
};

export default InvitationApi;
